<!-- 登录页面 - 支持账号密码登录和手机号验证码注册两种方式 -->
<!-- 页面挂载时自动检测URL中的token参数，实现外部系统免密跳转登录 -->
<!-- 支持回车键快捷提交表单 -->

<!-- data 属性说明 -->
<!-- innerHeight: 页面内容区高度，用于全屏适配 -->
<!-- formInline: 表单数据对象，包含 account(用户名)、pwd(密码)、phone(手机号)、code(验证码) -->
<!-- ruleInline: 账号登录表单验证规则 -->
<!-- ruleInlineCode: 手机号注册表单验证规则，含手机号格式校验 -->
<!-- codeValue: 验证码按钮状态，1-获取验证码 2-已发送 3-倒计时中 4-重发验证码 -->
<!-- timer: 验证码倒计时定时器引用 -->
<!-- timeValue: 验证码倒计时剩余秒数 -->
<!-- statusValue: 当前登录方式，1-账号密码登录 2-手机验证码注册 -->

<!-- methods 方法说明 -->
<!-- restHeight: 重新计算页面高度以适配窗口 -->
<!-- goSubmitForm: 提交登录/注册表单，根据 statusValue 选择账号登录或验证码登录，成功后将用户信息存入 localStorage 并跳转至管理后台 -->
<!-- getCode: 发送手机验证码，校验手机号格式后调用接口发送，并启动60秒倒计时 -->
<!-- goChangeStatus: 切换登录方式标签页，更新 statusValue -->
<!-- 登录页面 -->
<template>
    <div :style="'height:' + innerHeight + 'px;'">
        <div class="bg"></div>
        <div class="card-div">
            <div class="card">
                <Tabs value="1" @on-click="goChangeStatus">
                    <TabPane label="账号登录" name="1">
                        <Form
                            ref="formInline"
                            :model="formInline"
                            :rules="ruleInline"
                        >
                            <FormItem prop="account">
                                <div class="mb12 position-relative">
                                    <Input
                                        class="w1000"
                                        type="text"
                                        v-model="formInline.account"
                                        placeholder="用户名"
                                    />
                                    <Icon
                                        class="form-icon"
                                        size="20"
                                        type="md-person"
                                        color="#999"
                                    ></Icon>
                                </div>
                            </FormItem>
                            <FormItem prop="pwd">
                                <div class="mb12 position-relative">
                                    <Input
                                        class="w1000"
                                        password
                                        type="password"
                                        v-model="formInline.pwd"
                                        placeholder="账户密码"
                                    />
                                    <Icon
                                        class="form-icon"
                                        size="20"
                                        type="md-unlock"
                                        color="#999"
                                    ></Icon>
                                </div>
                            </FormItem>
                            <FormItem>
                                <Button @click="goSubmitForm"
                                    >点 击 登 录</Button
                                >
                            </FormItem>
                        </Form>
                    </TabPane>
                    <!-- <TabPane label="手机号注册" name="2">
                        <Form
                            ref="formInline"
                            :model="formInline"
                            :rules="ruleInlineCode"
                        >
                            <FormItem prop="phone">
                                <div class="mb12 position-relative">
                                    <Input
                                        class="w1000"
                                        type="text"
                                        v-model="formInline.phone"
                                        placeholder="手机号"
                                    />
                                    <Icon
                                        class="form-icon"
                                        size="20"
                                        type="md-phone-portrait"
                                        color="#999"
                                    ></Icon>
                                </div>
                            </FormItem>
                            <FormItem prop="code">
                                <div class="mb12 position-relative">
                                    <Input
                                        :disabled="
                                            codeValue == 1 ? true : false
                                        "
                                        class="w1000"
                                        type="text"
                                        v-model="formInline.code"
                                        placeholder="验证码"
                                    />
                                    <Icon
                                        class="form-icon"
                                        size="20"
                                        type="md-checkbox"
                                        color="#999"
                                    ></Icon>
                                    <div
                                        v-if="codeValue == 1"
                                        class="form-code"
                                        @click="getCode"
                                    >
                                        获取验证码
                                    </div>
                                    <div
                                        v-else-if="codeValue == 2"
                                        class="form-code-active"
                                    >
                                        已发送
                                    </div>
                                    <div
                                        v-else-if="codeValue == 3"
                                        class="form-code-active"
                                    >
                                        {{ timeValue }}S
                                    </div>
                                    <div
                                        v-else-if="codeValue == 4"
                                        class="form-code"
                                        @click="getCode"
                                    >
                                        重发验证码
                                    </div>
                                </div>
                            </FormItem>
                            <FormItem>
                                <Button @click="goSubmitForm"
                                    >点 击 注 册</Button
                                >
                            </FormItem>
                        </Form>
                    </TabPane> -->
                </Tabs>
            </div>
        </div>
    </div>
</template>
<script>
import { login, tokens, login_yzm, yzm_login } from "@/api/index";
import { windowsRise } from "@/utils/dom";
import { setCookies } from "@/utils/helper";
export default {
    data() {
        return {
            innerHeight: 0,
            formInline: {
                account: "",
                pwd: "",
                phone: "",
                code: "",
            },
            ruleInline: {
                account: [
                    {
                        required: true,
                        message: "用户名不能为空",
                        trigger: "blur",
                    },
                ],
                pwd: [
                    {
                        required: true,
                        message: "账户密码不能为空",
                        trigger: "blur",
                    },
                ],
            },
            ruleInlineCode: {
                phone: [
                    {
                        required: true,
                        message: "手机号不能为空",
                        trigger: "blur",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error("手机号不能为空"));
                            } else if (!/^1[3-9]\d{9}$/.test(value)) {
                                callback(new Error("请输入正确的11位手机号码"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "验证码不能为空",
                        trigger: "blur",
                    },
                ],
            },
            codeValue: 1,
            timer: null, // 定时器
            timeValue: 60,
            statusValue: 1, //短信登录
        };
    },
    metaInfo: {
        title: "首页",
        meta: [
            {
                name: "viewport",
                content:
                    "width=device-width,user-scalable=yes,initial-scale=0.3,minimum-scale=0.3,maximum-scale=2",
            },
        ],
    },
    mounted() {
        this.restHeight();
        windowsRise(window, this.restHeight);
        let hashPart = window.location.hash;
        let queryString = hashPart.replace(/^#\/\?/, "?");
        let params = new URLSearchParams(queryString);
        let tokenValue = params.get("token");
        if (tokenValue) {
            tokens({ token: tokenValue })
                .then((res) => {
                    this.$Message.success(res.msg);
                    this.handleLoginSuccess(res.data);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        }
    },
    created() {
        this.handleKeydown = (event) => {
            if (this.$route.name === "登录" && event.keyCode === 13) {
                this.goSubmitForm();
            }
        };
        document.onkeydown = this.handleKeydown;
    },
    beforeDestroy() {
        // 清除定时器
        if (this.timer) {
            clearInterval(this.timer);
        }
        // 清除键盘事件监听
        document.onkeydown = null;
    },
    methods: {
        restHeight() {
            this.innerHeight = window.innerHeight - 2;
        },
        handleLoginSuccess(data) {
            setCookies("pcToken", data.token);
            localStorage.setItem("user", data.account);
            localStorage.setItem("phone", data.phone);
            localStorage.setItem("id", data.id);
            localStorage.setItem("admin_id", data.admin_id);
            localStorage.setItem("demo_file_path", data.demo_file_path);
            localStorage.setItem("SUYUANPCQRCODELENGTH", data.qrcode_length);
            localStorage.setItem("SUYUANPCPID", data.pid);
            if (data.tips_path) {
                localStorage.setItem("tips_path", data.tips_path);
                localStorage.setItem("tips_link", data.tips_link);
            }
            this.$store.commit("setMenus", data.menu);
            localStorage.setItem("IDENTITYS", data.identitys);
            localStorage.setItem("app_ids", data.app_ids);
            this.$router.push({ path: "/admin" });
        },
        goSubmitForm() {
            var data;
            if (this.statusValue == 1) {
                if (this.formInline.account && this.formInline.pwd) {
                    data = {
                        account: this.formInline.account,
                        pwd: this.formInline.pwd,
                    };
                } else {
                    this.$Message.error("数据不能为空");
                    return;
                }
                login(data)
                    .then((res) => {
                        this.$Message.success(res.msg);
                        this.handleLoginSuccess(res.data);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else {
                if (this.formInline.phone && this.formInline.code) {
                    data = {
                        phone: this.formInline.phone,
                        code: this.formInline.code,
                    };
                } else {
                    this.$Message.error("数据不能为空");
                    return;
                }
                yzm_login(data)
                    .then((res) => {
                        this.$Message.success(res.msg);
                        this.handleLoginSuccess(res.data);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
        },
        getCode() {
            const phoneReg = /^1[3-9]\d{9}$/;
            if (!this.formInline.phone) {
                this.$Message.error("手机号不能为空");
                return;
            } else if (!phoneReg.test(this.formInline.phone)) {
                this.$Message.error("手机号格式不正确");
                return;
            }
            login_yzm({ phone: this.formInline.phone })
                .then((res) => {
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
            this.codeValue = 2;
            setTimeout(() => {
                this.codeValue = 3;
            }, 1000);
            // 开始倒计时
            this.timeValue = 60;
            this.timer = setInterval(() => {
                if (this.timeValue > 1) {
                    this.timeValue--;
                } else {
                    clearInterval(this.timer);
                    this.codeValue = 4;
                }
            }, 1000);
        },
        goChangeStatus(e) {
            this.statusValue = e;
        },
    },
};
</script>
<style scoped>
.bg {
    background: url("../../assets/login_bg.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
}
.card-div {
    margin: 0 0 0 20vw;
    min-width: 333px;
    width: 25vw;
    height: 100%;
    position: absolute;
    z-index: 999;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.card {
    border: 1px solid #ff761d;
    padding: 24px;
    border-radius: 10px;
}
.title {
    margin: 0 0 24px 0;
    font-weight: 600;
    font-size: 30px;
    color: #ff761d;
}
.position-relative {
    position: relative;
}
.w1000 {
    width: 100%;
}
.form-icon {
    width: 20px;
    height: 20px;
    position: absolute;
    left: 10px;
    top: 14px;
    z-index: 999;
}
.form-code {
    position: absolute;
    right: 12px;
    top: 9px;
    z-index: 999;
    color: #ff761d;
    font-size: 12px;
    cursor: pointer;
}
.form-code-active {
    position: absolute;
    right: 12px;
    top: 9px;
    z-index: 999;
    color: #808080;
    font-size: 13px;
    cursor: pointer;
}
::v-deep .ivu-tabs-tab:hover {
    color: #ff761d;
}
::v-deep .ivu-tabs-nav .ivu-tabs-tab-active {
    color: #ff761d;
    font-size: 16px;
}
::v-deep .ivu-tabs-tab {
    font-size: 16px;
}
::v-deep .ivu-tabs-ink-bar {
    background-color: #ff761d !important;
}
::v-deep .ivu-tabs-bar {
    border-bottom: none;
    margin-bottom: 33px;
}
::v-deep .ivu-tabs-nav-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
}
::v-deep .ivu-input {
    padding: 0 0 0 40px;
    height: 50px;
    background: #ffffff;
    border-radius: 25px;
    border: 1px solid #ccc;
    font-size: 16px;
}
::v-deep .ivu-btn {
    width: 100%;
    height: 50px;
    background: linear-gradient(90deg, #ff761d 0%, #ff761d 100%);
    border-radius: 25px;
    font-size: 16px;
    color: #ffffff;
}
::v-deep .ivu-input-suffix i {
    line-height: 50px;
}
</style>